import Route from 'rise-ui/utils/routing/route.js';

import { service } from '@ember/service';

import { scrollRoot } from 'rise-ui/services/scroll-root.js';
import { buildJsonLd, catalogRecordDataset } from 'rise-ui/utils/data';

@scrollRoot
export default class CatalogRecordIndexRoute extends Route {
  @service dataset;
  @service keywords;

  setHeadTags(model) {
    const record = model?.record;
    this.headTags = [
      {
        type: 'meta',
        attrs: {
          name: 'description',
          content: record.description,
        },
      },
      {
        type: 'meta',
        attrs: {
          name: 'keywords',
          content: this.keywords.keywords(
            false,
            record.themes,
            record.tags,
          ),
        },
      },
      {
        type: 'script',
        attrs: {
          type: 'application/ld+json',
        },
        content: buildJsonLd(catalogRecordDataset(record, this.dataset.urlFn)),
      },
    ];
  }
}
